import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeColor, Flex, Box, Copy, Selector } from '@elparking/components'

import VehicleInspectionSelector from 'commons/js/components/VehicleInspectionTypeSelector'
import { FormattedMessage } from 'react-intl'
import { Events, trackEvent } from 'commons/js/services/analytics'

const VehicleTypeSelectorElementContainer = styled(Selector)`
    border: 0;
    background: ${themeColor('white')};
    box-shadow: none;
`

const VehicleTypeSelectorContainer = styled(Flex)`
    background: ${themeColor('white')};
    border: 1px solid ${themeColor('lightGray40')};
`

function VehicleFilterSelectorContainer ({vehicleFilter, setVehicleFilter, trackEvent}) {
    return (
        <VehicleTypeSelectorContainer flexWrap='wrap' mx='12px' mb='1.5em'>
            {
                vehicleFilter &&
                <Box w='100%' pl='0.8em' pt='4px'>
                    <Copy as='span' color='gray60' fontWeight='medium' lineHeight='0' size='xxxSmall' transform='uppercase' padding='0'>
                        <FormattedMessage defaultMessage='Tipo de vehículo' />
                    </Copy>
                </Box>
            }
            <Box w='100%'>
                <VehicleInspectionSelector
                  width='100%'
                  defaultValue={vehicleFilter}
                  onChange={(filter) => {
                      setVehicleFilter(filter)
                      trackEvent(Events.vehicleInspectionStationChangeVehicleType, filter.value)
                  }}
                  selectorElement={VehicleTypeSelectorElementContainer}
                  renderPlaceholder={() => <Box p='16px 12px'><FormattedMessage defaultMessage='Selecciona el tipo de vehículo' /></Box>}
                />
            </Box>
        </VehicleTypeSelectorContainer>
    )
}

VehicleFilterSelectorContainer.propTypes = {
    vehicleFilter: PropTypes.string,
    setVehicleFilter: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
}

VehicleFilterSelectorContainer.defaultProps = {
    trackEvent,
}

export default VehicleFilterSelectorContainer
